<template>
    <div class="content_warpper">
        <el-table :data="tableData" border>
            <el-table-column type="index" label="序号"></el-table-column>
            <el-table-column label="操作" width="180">
                <template slot-scope="scoped">
                    <el-button @click="edit(scoped)" type="text">{{ $t('common.edit') }}</el-button>
                </template>
            </el-table-column>
            <el-table-column label="编号类型" prop="type" width="180"></el-table-column>
            <el-table-column label="编号前缀" prop="begin" width="180"></el-table-column>
            <el-table-column label="编号位数" prop="digit" width="180"></el-table-column>
            <el-table-column label="网页版编号规则" prop="rule"></el-table-column>
        </el-table>
        <div class="pagination">
            <el-pagination
                background
                layout="total, prev, pager, next"
                :current-page="pageIndex"
                :page-sizes="[5, 10, 20, 50, 100]"
                :page-size="pageSize"
                :total="pageTotal"
                @current-change="handlePageChange"
                @size-change="pageSizeChange"
            ></el-pagination>
        </div>
        <el-drawer :title="isAdd ? $t('common.add') : $t('common.edit')" :visible.sync="drawer" direction="rtl" :before-close="handleClose">
            <div class="form_warpper">
                <el-form :model="addData" ref="addform" label-width="" label-position="left" :rules="rules">
                    <!-- <el-form-item label="仓库名称" prop="store_name">
                        <el-input v-model="addData.store_name" disabled></el-input>
                    </el-form-item> -->
                    <el-form-item label="编号前缀" prop="begin">
                        <el-input v-model="addData.begin" @input="changeBegin"></el-input>
                    </el-form-item>
                    <el-form-item label="编号位数" prop="digit">
                        <el-input v-model="addData.digit" @input="changeDigit"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <template>
                            <el-checkbox label="年" v-model="addData.year" @change="changeBox('year', $event)"></el-checkbox>
                            <el-checkbox label="月" v-model="addData.month" @change="changeBox('month', $event)"></el-checkbox>
                            <el-checkbox label="日" v-model="addData.day" @change="changeBox('day', $event)"></el-checkbox>
                        </template>
                    </el-form-item>
                    <el-form-item label="编号类型">
                        <el-input v-model="addData.type" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="网页版编号样例">
                        <div class="case_warpper">
                            <el-input v-model="addData.cases" disabled class="input"></el-input>
                            <p>WD{YYYYY}{MM}{DD}{##}</p>
                        </div>
                    </el-form-item>
                    <!-- <el-form-item label="当前编号">
                        <div class="case_warpper">
                            <el-input v-model="addData.begin" disabled class="input"></el-input>
                            <p>网页版当前即将使用到的编号</p>
                        </div>
                    </el-form-item> -->
                </el-form>
                <div class="dialog-footer">
                    <el-button type="primary" @click="saveIt">确 定</el-button>
                    <el-button @click="drawer = false">取 消</el-button>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { oddIndex, oddUpdate } from '@/request/api.js';
export default {
    name: 'oddruleset',
    data() {
        return {
            tableData: [],
            pageTotal: 0,
            pageIndex: 1,
            pageSize: 10,
            drawer: false,
            addData: {},
            rules: {
                begin: [
                    {
                        required: true,
                        message: '请输入编号前缀',
                        trigger: 'change'
                    }
                ]
            },
            isAdd: false
        };
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.$load.show();
            oddIndex({
                page: this.pageIndex,
                page_size: this.pageSize
            }).then(res => {
                this.$load.close();
                if (res.code == 2000) {
                    this.tableData = res.data.data;
                    this.pageTotal = res.data.count;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        edit(scoped) {
            this.addData = scoped.row;
            this.addData.year = Boolean(scoped.row.year);
            this.addData.month = Boolean(scoped.row.month);
            this.addData.day = Boolean(scoped.row.day);
            this.setModel();
            this.drawer = true;
        },
        saveIt() {
            oddUpdate({
                id: this.addData.id,
                rule: this.addData.rule,
                begin: this.addData.begin,
                digit: this.addData.digit
            }).then(res => {
                this.drawer = false;
            });
        },
        handleClose() {
            this.drawer = false;
        },
        setModel() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let cases = '';
            let begin = this.addData.begin;
            let num = this.addData.digit;
            let y = 'Y';
            let m = 'm';
            let d = 'd';
            if (this.addData.year == 0) {
                year = '';
                y = '';
            }
            if (this.addData.month == 0) {
                month = '';
                m = '';
            }
            if (this.addData.day == 0) {
                day = '';
                d = '';
            }
            cases = begin + year + month + day + num;
            this.addData.cases = cases;
            this.addData.rule = y + m + d;
        },
        changeBox(type, e) {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let rule = '';
            let begin = this.addData.begin;
            let num = this.addData.digit;
            let y = 'Y';
            let m = 'm';
            let d = 'd';
            if (type == 'year' && !e) {
                year = '';
                y = '';
            }
            if (type == 'month' && !e) {
                month = '';
                m = '';
            }
            if (type == 'day' && !e) {
                day = '';
                d = '';
            }
            rule = begin + year + month + day + num;
            this.addData.cases = rule;
            this.addData.rule = y + m + d;
        },
        changeBegin() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let rule = '';

            if (!this.addData.year) {
                year = '';
            }
            if (!this.addData.month) {
                month = '';
            }
            if (!this.addData.day) {
                day = '';
            }
            rule = this.addData.begin + year + month + day + this.addData.digit;
            this.addData.cases = rule;
        },
        changeDigit() {
            let date = new Date();
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            let day = date.getDate();
            let rule = '';

            if (!this.addData.year) {
                year = '';
            }
            if (!this.addData.month) {
                month = '';
            }
            if (!this.addData.day) {
                day = '';
            }
            rule = this.addData.begin + year + month + day + this.addData.digit;
            this.addData.cases = rule;
        },
        // 分页导航----------------------------------------------------------------------------------------------------
        handlePageChange(val) {
            this.pageIndex = val;
            this.getData();
        },
        pageSizeChange(val) {
            this.pageSize = val;
            this.getData();
        }
    }
};
</script>

<style scoped lang="scss">
.content_warpper {
    background-color: #fff;
    padding: 20px;
    box-sizing: border-box;
}

.form_warpper {
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;
    padding-right: 160px;

    .dialog-footer {
        width: 100%;
        border-top: 1px solid #e7e7e7;
        position: absolute;
        bottom: 0;
        padding: 20px 0;
    }
    .case_warpper {
        width: 100%;
        display: flex;
        .input {
            width: 0;
            flex: 1;
        }
        p {
            font-size: 12px;
            color: #666;
        }
    }
}
</style>
